import type { ReactNode } from 'react'

/**
 * Empty stub module for production builds.
 * Vite aliases @/app/devtools/runtime to this file in production mode so
 * console-only controls stay out of production bundles.
 */
export interface DevConsoleProviderProps {
  children: ReactNode
}

export const DevConsoleProvider = ({ children }: DevConsoleProviderProps) => children

export const useAtcDevtoolsOverrideUrl = (): string | null => null

export default DevConsoleProvider